import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeatmapService } from '../services/heatmap.service';

import * as d3 from 'd3';
import { ClickEvent } from '@common';

@Component({
  selector: 'app-heatmap',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.scss']
})
export class HeatmapComponent implements AfterViewInit, OnDestroy {
  width = 1600
  height = 900
  densityData: [number, number][] = []
  private resizeObserver?: ResizeObserver;

  constructor(
    public heatmapService: HeatmapService
  ) {}

  ngAfterViewInit() {
    this.heatmapService.clickEvents$.subscribe(data => {
      if (data.length > 0) {
        this.buildHeatMap(data)
      } else {
        const svg = d3.select('#heatMap');
        
        svg.selectAll("*").remove();
      }
    })

    // Set up ResizeObserver to watch the container element
    // Using querySelector to avoid ViewChild - observes the parent div of the SVG
    const containerElement = document.querySelector('#heatMap')?.parentElement;
    if (containerElement) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.width = entry.contentRect.width;
          this.height = entry.contentRect.height;
          this.redrawHeatMap();
        }
      });
      this.resizeObserver.observe(containerElement);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  buildHeatMap(clickArray: ClickEvent[]): void {
    this.densityData = this._flattenClicks(clickArray)
    this.redrawHeatMap()
  }

  redrawHeatMap(): void {
    const svg = d3.select('#heatMap');
    
    svg.selectAll("*").remove();
    svg.attr('width', this.width)
      .attr('height', this.height)

    const xScale = d3.scaleLinear().domain([0, 100]).range([0, this.width])
    const yScale = d3.scaleLinear().domain([0, 100]).range([0, this.height])
    const color = d3.scaleSequential(t => {
      const alpha = Math.pow(t, 0.3);
      return `rgba(0, 255, 0, ${alpha})`;
    });
    
    const contourData = d3.contourDensity()
      .x(d => xScale(d[0]))
      .y(d => yScale(d[1]))
      .size([this.width, this.height])
      .bandwidth(15)(this.densityData);
    
    svg.selectAll('path')
      .data(contourData)
      .enter().append('path')
      .attr('d', d3.geoPath())
      .attr('fill', (d) => color(d.value))
  }

  _flattenClicks(data: ClickEvent[]): [number, number][] {
    return data.map(event => [event.args.x, event.args.y])
  }
}
